/**
 * Created by mohameds on 18/7/19.
 */
import React, {Component} from 'react'
import NumberFormat from 'react-number-format';
import {Table} from 'reactstrap';
import loadingGIF from "../../public/assets/images/loading.gif";


class IndividualPage extends Component {

    state = {
        pageData: {},
        kpiGoalObj: {},
        kpiActualObj: {},
        totalObj: {},
        loading: false
    };

    componentDidMount = () => {
        this.setState({loading: true}, () => {
            this.getPageData()
        })
    };

    componentDidUpdate = (prevProps) => {
        if (prevProps.keyValue !== this.props.keyValue) {
            this.getPageData();
        }
    };

    getPageData = async() => {
        try {
            let res = await this.props.actions.MonitorPage.getIndividualPageData(this.props.pageObj);
            if (res) {
                this.setState({
                    pageData: this.props.agencyMonitor.individualPageData,
                    loading: false
                }, () => {
                    this.getKpiDataObj()
                })
            }
        }
        catch (error) {
            this.setState({loading: false});
        }
    };

    getKpiDataObj = () => {
        let kpiGoalObj = {...this.state.kpiDataObj};
        let kpiActualObj = {...this.state.kpiActualObj};
        let {pageData} = this.state;
        let key = '';
        pageData.data_list.map(kpiData => {
            key = kpiData.user + "_" + kpiData.kpi;
            kpiGoalObj[key] = kpiData.goal;
            kpiActualObj[key] = kpiData.actual;
        });
        this.setState({kpiGoalObj, kpiActualObj})
    }

    render() {
        const {pageData, kpiGoalObj, kpiActualObj} = this.state;
        let headings = [], rows = [], heading2 = [];
        let key = '', goal, goalFormat, actual, actualFormat;

        pageData.user_list && pageData.user_list.map((user, index) => {
            let cols = [];
            cols.push(<td key={'user' + user.id}>{user.full_name}</td>);
            pageData.kpi_list && pageData.kpi_list.map((kpi, ind) => {
                key = user.id + "_" + kpi.id;
                goal = key in kpiGoalObj ? kpiGoalObj[key] : 0;
                actual = key in kpiActualObj ? kpiActualObj[key] : 0;
                //count = 0;
                if (kpi.data_type === "Currency") {
                    goalFormat = <NumberFormat key={index} value={goal}
                                    displayType={'text'} thousandSeparator={true}
                                    decimalScale={0} prefix={'$'}
                                    className="font-22"
                                />;
                    actualFormat = <NumberFormat key={index} value={actual}
                                        displayType={'text'} thousandSeparator={true}
                                        decimalScale={0} prefix={'$'}
                                        className="font-22"
                                    />;
                } else if (kpi.data_type === "Percentage") {
                    goalFormat = <NumberFormat key={index} value={goal}
                                    displayType={'text'} thousandSeparator={true}
                                    decimalScale={2} suffix={'%'}/>;
                    actualFormat = <NumberFormat key={index} value={actual}
                                        displayType={'text'} thousandSeparator={true}
                                        decimalScale={2} suffix={'%'}/>;
                } else {
                    goalFormat = <NumberFormat key={index} value={goal}
                                        displayType={'text'} thousandSeparator={true}
                                        decimalScale={0}/>;
                    actualFormat = <NumberFormat key={index} value={actual}
                                        displayType={'text'} thousandSeparator={true}
                                        decimalScale={0}/>;
                }
                cols.push(
                    <React.Fragment key={ind}>
                        {pageData.goal && <td className="text-center" key={key + ind}>{goalFormat}</td> }
                        <td className="text-center text-success" key={key + '-' + ind}>{actualFormat}</td>
                    </React.Fragment>
                );
            });
            rows.push(<tr key={index}>{cols}</tr>);
        });

        headings.push(<th key={-1} rowSpan={2} className="font-weight-bold staff-td-width">Staff Name</th>);
        pageData.kpi_list && pageData.kpi_list.map((kpi, index) => {
            headings.push(
                <th colSpan={pageData.goal ? 2 : 1} className="daily-activity-th align-middle" key={index}>
                    {kpi.name}
                </th>
            );
            heading2.push(
                <React.Fragment key={index}>
                    {pageData.goal && <td className="text-center align-middle" key={index + 1}>Goal</td> }
                    <td className="text-center align-middle" key={index + 2}>Actual</td>
                </React.Fragment>
            );
        });
        return (
            <React.Fragment>
                {
                    this.state.loading ?
                        <div className="text-center" style={{position: 'relative', top: '30%'}}>
                            <img src={loadingGIF} alt="loading..." width="64"/>
                        </div> :
                        <div className="container-fluid my-1">
                            <div className="row">
                                <div className="col-12 text-center">
                                    <p className="display-6 font-weight-bold">
                                        {pageData && pageData.title && pageData.title}
                                    </p>
                                    <span className="hor-bar"/>
                                </div>
                                <div className="col-12">
                                    <Table responsive striped bordered size="sm" 
                                        className="mb-0 font-26 bg-white">
                                        <thead className="bg-info">
                                            <tr className="text-white">
                                                {headings}
                                            </tr>
                                            <tr className="bg-warning">
                                                {heading2}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr/>
                                                {rows}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                }
            </React.Fragment>
        )
    }
}
export default IndividualPage


// WEBPACK FOOTER //
// ./src/components/agencyMonitor/IndividualPage.js